@if (apiFragment$ | async; as record) {
  <dt class="sh-description-list__term">{{ label }}</dt>
  <dd class="sh-description-list__details edp-subject-process-details">
    <ul class="edp-unstyled-list">
      <li>{{ record.metadata.Dynamic.SeriesProcess?.Scope?.Label || '-' }}</li>
      @if (record.metadata.Dynamic.SeriesProcess?.Task?.Label) {
        <li>{{ record.metadata.Dynamic.SeriesProcess?.Task?.Label }}</li>
      }
      @if (record.metadata.Dynamic.SeriesProcess?.Action?.Label) {
        <li>{{ record.metadata.Dynamic.SeriesProcess?.Action?.Label }}</li>
      }
    </ul>
  </dd>
}
